export class CoalesceValueConverter {
	toView(value: any, replacement: any) {
		return value ? value : replacement;
	}
}